import { ANWBDefault } from '@anwb/theme';
import { createVariant } from '../../utils/createVariant';
export const LinkText = createVariant({
    name: 'link-text',
    tagName: 'a',
    baseStyle: ({ theme }) => (Object.assign(Object.assign({}, (theme.typography.paragraphs['100LinkText'] ||
        theme.typography.captions['50SupportLinkText'])), { color: theme.colors.highlight.textLink, colorHover: theme.name === ANWBDefault.name
            ? theme.colors.base.textLink
            : theme.colors.base.textBodyLinkHover, cursor: 'pointer' })),
});
//# sourceMappingURL=LinkText.js.map